/* eslint-disable prefer-const */
import { keysLS, getLSItem, setLSItem, removeLSItem } from './localStorageProvider';

const Language = (() => {
  let props = new WeakMap();
  return class {
    constructor(locale, paths) {
      props.set(this, {
        locale: locale || 'en',
        filter: (lang) => {
          switch (lang.toLowerCase().match(/^[^(,|;)]*/i)[0]) {
            case 'zh':
            case 'zh-hk':
            case 'zh-hant':
            case 'zh-tw':
            case 'zh-sg':
            case 'yue-hk':
              return 'zh-hk';
            case 'zh-cn':
            case 'zh-hans':
              return 'zh-cn';
            case 'fr':
              return 'fr';
            case 'it':
              return 'it';
            case 'en':
            case 'en-us':
            case 'en-gb':
            default:
              return 'en';
          }
        },
        paths,
      });
    }

    getDictionary() {
      const { locale, paths } = props.get(this);

      let defaultDict = require(`shared/translations/${locale}.json`) || {};

      let customDict = {};
      if (paths && paths.length) {
        customDict = paths.reduce(function(result, currentPath) {
          const currentObject = require(`../../src/${currentPath}/${locale}.json`) || {};

          Object.keys(currentObject).forEach((key) => {
            if (currentObject.hasOwnProperty(key)) {
              result[key] = currentObject[key];
            }
          });

          return result;
        }, {});
      }

      let savedDict = {};
      if (getLSItem(keysLS.langData)) {
        try {
          savedDict = JSON.parse(getLSItem(keysLS.langData));
        } catch (error) {
          removeLSItem(keysLS.langData);
        }
      }

      const dictionary = { ...savedDict, ...defaultDict, ...customDict };
      setLSItem(keysLS.langData, JSON.stringify(dictionary));

      return dictionary;
    }
  };
})();

export default Language;
